export const USERS_PERMISSIONS = {
  TEAM_VIEW: 'team.view',
  APPROVE_MEMBERS: 'admin.approveMembers',
  MANAGE_PERMISSIONS: 'admin.managePermissions',
};

export const USERS_PRIMARY_NAV_ITEMS = [
  {
    key: 'team',
    label: 'Team',
    path: '/team',
    permission: USERS_PERMISSIONS.TEAM_VIEW,
  },
  {
    key: 'user-management',
    label: 'User Management',
    path: '/user-management',
    permission: USERS_PERMISSIONS.APPROVE_MEMBERS,
  },
];

export const USERS_ADMIN_NAV_ITEMS = [];
